import { Link, useParams } from 'react-router-dom';
import { getNewsById, getRelatedNews } from '@/mocks/news';
import { usePageMeta } from '@/hooks/usePageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function NewsDetail() {
  const { id } = useParams();
  const item = getNewsById(Number(id));

  usePageMeta({
    title: item ? `${item.title} - 影视资讯详细内容` : '影视资讯 - 北条麻妃电影',
    description: item ? item.summary : '北条麻妃影视资讯详细内容。',
    keywords: item
      ? `${item.category},北条麻妃电影资讯,影视动态,${item.title}`
      : '北条麻妃电影资讯',
  });

  if (!item) {
    return (
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-newspaper-line text-2xl"></i>
        </span>
        <h1 className="mt-5 text-xl font-bold text-foreground-950">暂无相关资料</h1>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          很抱歉，这条资讯可能已被移除或链接有误。
        </p>
        <Link
          to="/news"
          className="mt-6 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = getRelatedNews(item, 3);

  return (
    <>
      <div className="mx-auto w-full max-w-4xl px-4 pt-8 md:px-6 md:pt-10">
        <Breadcrumb
          items={[{ label: '首页', to: '/' }, { label: '资讯动态', to: '/news' }, { label: item.category }]}
        />
      </div>

      <article className="mx-auto w-full max-w-4xl px-4 py-8 md:px-6 md:py-10">
        <div className="flex flex-wrap items-center gap-3">
          <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            {item.category}
          </span>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-user-line"></i>
            {item.author}
          </span>
        </div>

        <h1 className="mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {item.title}
        </h1>

        <p className="mt-4 rounded-lg border-l-2 border-accent-500 bg-background-100/70 px-4 py-3 text-sm leading-relaxed text-foreground-700">
          {item.summary}
        </p>

        <div className="mt-6 aspect-[16/9] w-full overflow-hidden rounded-lg bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 影视资讯`}
            className="h-full w-full object-top"
          />
        </div>

        <div className="mt-8 flex flex-col gap-5">
          {item.content.map((para, i) => (
            <p key={i} className="text-sm leading-loose text-foreground-700 md:text-base">
              {para}
            </p>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-background-200 pt-6">
          <p className="text-xs text-foreground-500">
            本文为演示样例内容，仅供展示与学习交流使用。
          </p>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </div>
      </article>

      {related.length > 0 && (
        <section className="mx-auto w-full max-w-4xl px-4 pb-16 md:px-6">
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">相关资讯</h2>
          <div className="mt-5 flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {related.map((r) => (
              <Link
                key={r.id}
                to={`/news/${r.id}`}
                className="group flex items-start gap-4 p-4 transition-colors hover:bg-background-100 md:p-5"
              >
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className="ri-article-line text-base"></i>
                </span>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                    {r.title}
                  </h3>
                  <p className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{r.category}</span>
                    <span>{r.date}</span>
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </>
  );
}